import { render, staticRenderFns } from "./Popupbox.vue?vue&type=template&id=5518b34a&scoped=true&"
import script from "./Popupbox.vue?vue&type=script&lang=js&"
export * from "./Popupbox.vue?vue&type=script&lang=js&"
import style0 from "./Popupbox.vue?vue&type=style&index=0&id=5518b34a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5518b34a",
  null
  
)

export default component.exports